<template>
  <div id="page-Settle" class="d-flex">
    <MainBarMenu />
     <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
 
      
    <div class="layout-content container-fluid div1 ">
      <HeadingUser />  
      <div class="layout-content container-fluid mt-5">
        <div class="row">
          <div
            class="col-m-12 col-lg-4 charge-file"
            align="center"
          >
            <h2 class="mt-0 mt-md-3 mt-lg-4">Nuevo Derecho de Petición</h2>
            <form
              @submit="saveRightPetition"
              onsubmit="return false"
              id="file-upload-form"
            >
              <div class="file-upload-img">
                <input
                  type="file"
                  id="fileDocu"
                  @change="fileSelected"
                  accept=".tif, .pdf"
                  required
                />
                <span v-if="!nameFile">
                  <img src="@/assets/images/settler/uploadFile.jpg" />
                </span>
                <span v-else style="display: table; margin: 0 auto">
                  <p class="p3">
                    <b>{{ nameFile }}</b>
                  </p>
                </span>
              </div>
              <div class="mt-5">
                <h3 class="mt-0 mt-md-3 mt-lg-4 text-left">
                  <label for="checked_radicado"
                    >¿Como recibió el derecho de petición?
                    <div class="d-flex my-3">
                      <!--<input type="checkbox" id="checked_radicado"  v-model="reqFiling">-->
                      <div class="form-check mx-5">
                        <input
                          class="form-check-input"
                          v-model="reqFiling"
                          type="radio"
                          value="1"
                          id="flexRadioDefault1"
                          selected
                        />
                        <label class="form-check-label" for="flexRadioDefault1">
                          Físico
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="reqFiling"
                          value="0"
                          id="flexRadioDefault2"
                          checked
                        />
                        <label class="form-check-label" for="flexRadioDefault2">
                          Correo
                        </label>
                      </div>
                    </div>
                  </label>
                </h3>
              </div>
              <div class="mt-5" v-if="reqFiling == 1">
                <h3 class="mt-0 mt-md-3 mt-lg-4 text-left">
                  Número de radicado
                </h3>
                <input
                  v-model="numSettled"
                  type="text"
                  class="form-control"
                  required
                />
              </div>
              <div class="mt-0">
                <h3 class="mt-0 mt-md-3 mt-lg-4 text-left">Categoría</h3>
                <b-form-select
                  v-model="ctgoria"
                  :options="opcionCategories"
                  size="lg"
                  class="mt-0"
                  required
                  @change="subcategorias"
                >
                </b-form-select>
              </div>
              <!--<div class="mt-0">
                <h3 class="mt-0 mt-md-3 mt-lg-4 text-left">Subcategoría</h3>
                <b-form-select
                  v-model="subctgoria"
                  :options="opcionSubcategories"
                  size="lg"
                  class="mt-0"
                  required
                >
                </b-form-select>
              </div>-->
              <div class="mt-5" align="center">
                <div v-if="!loading">
                  <button type="submit" class="btn btn-darkblue-1">
                    Cargar
                  </button>
                </div>
                <div v-else-if="loading" class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <small v-show="error.flag" class="alert-danger">{{
                error.message
              }}</small>
            </form>
          </div>
          <div>
            <b-modal
              ref="my-modal"
              hide-footer
              centered
              title="Atención al mensaje:"
              no-close-on-backdrop
              @hidden="hideModal"
            >
              <div class="d-block text-center">
                <h3>{{ this.msjModal }}</h3>
              </div>
              <b-button
                class="mt-3"
                variant="outline-danger"
                block
                @click="hideModal"
              >
                Cerrar
              </b-button>
            </b-modal>
          </div>

          <div class="col-md-12 col-lg-8 py-4">
            <h2 class="mt-0 mt-md-3 mt-lg-4">Solicitudes</h2>
            <!-- .col -->
            <div class="col-12 col-md-0 text-left text-lg-right">
              <div
                class="cont-search d-flex flex-column align-items-start align-items-md-end"
              >
                <label for="filter d-block">Ingresa palabra clave</label>
                <div class="cont-input d-flex">
                  <input
                    type="text"
                    class="input-text"
                    v-model="datatable.filter"
                    placeholder="Introduce tu búsqueda..."
                    @keyup="$event.stopImmediatePropagation(),getFilterDp()"
                  />
                  <button class="d-flex align-items-center px-3">
                    <span>Buscar</span>
                    <span class="icon icon-search ml-3"></span>
                  </button>
                </div>
              </div>
            </div>
            <!-- .col -->
            <!-- .row -->
            <div class="data-table row mt-5 mt-md-5">
              <div class="col-12">
                <!--div v-if="loading" id="loader"></div-->
                <div class="table-responsive">
                  <datatable
                    :columns="datatable.columns"
                    :data="datatable.rows"
                    :filter="datatable.filter"
                    :per-page="datatable.perPage"
                    :page="datatable.page"
                    sort="id:desc"
                  >
                    <template slot-scope="{ row, columns }">
                      <tr @click="funcion(row)">
                        <template>
                          <datatable-cell
                            v-for="(column, j) in columns"
                            :key="j"
                            :column="column"
                            :row="row"
                          >
                          </datatable-cell>
                        </template>
                      </tr>
                    </template>
                  </datatable>
                  <!-- <div class="col-12 col-md-12 cont-pagination text-center">
                    <datatable-pager
                      v-model="datatable.page"
                      type="short"
                      :per-page="per_page"
                    ></datatable-pager>
                  </div> -->

                  <div class="cont-no-data" v-show="datatable.rows.length <= 0">
                    <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                      <img
                        src="@/assets/images/demands/user-mail.svg"
                        alt="user email"
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <small v-show="error.flag" class="alert-danger">{{
                error.message
              }}</small>
              <!-- .col-12 -->
              <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
                <Pagination :data="rightPetition.data" @pagination-change-page="getFilterDp"></Pagination>
              </div>
              <!-- .col -->
              <div
                class="col-12 col-md-6 form-inline cont-pagintation text-left text-md-right"
              >
                <!--datatable-pager v-model="datatable.page" type="abbreviated" :per-page="datatable.perPage"></datatable-pager-->
              </div>
            </div>
            <!-- .row -->
            <div class="mb-menu"></div>
          </div>
        </div>
        <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-alldemands -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
import Pagination from "laravel-vue-pagination";

export default {
  name: "Settle",
  components: {
    MainBarMenu,
    HeadingUser,
    Pagination
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      days: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      monthNames: [
        "cero",
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
      msjModal: "",
      flagPath: "",
      nameFile: "",
      numSettled: "",
      reqFiling: 1,
      ctgoria: "",
      opcionCategories: [],
      subctgoria: "",
      opcionSubcategories: [],
      cont: 0,
      faqDetail: [],
      rightPetitionRows: [],
      datatable: {
        filter: "",
        perPage: 9,
        page: 1,
        columns: [
          {
            label: "Categoría",
            field: "category",
            align: "left",
            sortable: true,
            interpolate: true,
            headerClass: "theading",
          },
          {
            label: "ID Solicitud",
            field: "id",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Beneficiario",
            field: "beneficiary",
            align: "left",
            headerClass: "theading",
            interpolate: true,
          },
          {
            label: "N° de Radicado",
            field: "number",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Fecha Solicitud",
            field: "date",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Estado",
            field: "state",
            align: "left",
            headerClass: "theading",
            interpolate: true,
          },
        ],
        rows: [],
      },
    };
  },
  beforeMount() {
    let data2 = {
            'page':1
            };
    this.actGetRightPetition(data2).then(() => {
      this.loadRows();
    });

    this.actGetCategories().then(() => {
        this.categories.data.forEach((category) => {
        this.opcionCategories.push({
          value: category.id,
          text: category.name,
        });
      });
    });
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modSettle", ["categories", "rightPetition", "loading"]),

    countAllDemands() {
      return this.datatable.rows.length;
    },
  },
  methods: {
    ...mapActions("modSettle", [
      "actGetCategories",
      "actSaveRightPetition",
      "actGetRightPetition",
    ]),

    getFilterDp(page = 1){
    let data2 = [];
    data2 = {
            'page': page,
            'filter': this.datatable.filter,
            };
      //alert(JSON.stringify(data));
     this.actGetRightPetition(data2).then(() =>{
            this.datatable.rows = []
            this.loadRows();
          })
          .catch((response) => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message = "No se pudo conectar al servicio: error: "+response;
          });
    },

    subcategorias() {
      this.opcionSubcategories = [];
      this.subctgoria = "";
      this.categories.data.forEach((r) => {
        if (r.id == this.ctgoria) {
          r.pr_subcategories.forEach((s) => {
            this.opcionSubcategories.push({
              value: s.id,
              text: s.name,
            });
          });
        }
      });
    },

    fileSelected() {
      const dato = document.querySelector("#fileDocu");
      this.nameFile = dato.files[0].name;
    },

    saveRightPetition() {
      var formData = new FormData();

      const fileSelected = document.querySelector("#fileDocu");
      let extFile = fileSelected.files[0].name.split(".");
      if (extFile[1].toString().toLowerCase() == "pdf" || extFile[1].toString().toLowerCase() == "tif") {
        formData.append("file", fileSelected.files[0]);
        formData.append("filing_number", this.numSettled);
        formData.append("require_filing", this.reqFiling);
        formData.append("subcategory_id", 0);
        formData.append("category_id", this.ctgoria);

        this.actSaveRightPetition(formData)
          .then(() => {
            let data2 = {
            'page':1
            };
            this.actGetRightPetition(data2).then(() => {
              this.datatable.rows = [];
              this.loadRows();
            });
            this.nameFile = "";
            this.numSettled = "";
            this.reqFiling = 1;
            this.subctgoria = "";
            this.ctgoria = "";

            this.showModal(
              "El derecho de petición se registró correctamente",
              0
            );
          })
          .catch((response) => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message =
              "Ocurrio un error al actualizar los datos: " + response;
          });
      } else {
        this.showModal("El sistema solo acepta archivos .pdf", 0);
      }
    },

    loadRows() {
    const dataService = this.rightPetition.data;
    let statusRequest = [];
    for(let i=0; i<dataService.data.length; i++){
        //Estado solicitud
        if(dataService.data[i].status == "closed"){
          statusRequest[i] = {
            icon: "circle-check",
            text: "Cerrado",
          }
        }
        if(dataService.data[i].status == "open"){
          statusRequest[i] = {
            icon: "circle-clock",
            text: "Abierta",
          }
        }
        if(dataService.data[i].status == "pending"){
          statusRequest[i] = {
            icon: "circle-clock",
            text: "Pendiente",
          }
        }
        if(dataService.data[i].status == "closing"){
          statusRequest[i] = {
            icon: "eye",
            text: "Cerrando",
          }
        }        
      }
    for(let i=0; i<dataService.data.length; i++){
      this.datatable.rows.push({
        category: (dataService.data[i].category_name == null)? '' : dataService.data[i].category_name,
        id: dataService.data[i].id,
        beneficiary:(dataService.data[i].beneficiary_name == null)? `<span style="color:#e0e0e0">Sin Diligenciar</span>`:dataService.data[i].beneficiary_name,
        number:dataService.data[i].filing_number,
        date: this.formatDateShow(dataService.data[i].created_at),
        state: `<span class="icon icon-${statusRequest[i].icon}"></span> ${statusRequest[i].text}`
      });
    }
},

    funcion(row) {
      this.cont = this.faqDetail.findIndex((faq) => faq.id === row.id);
    },

    formatDateShow(date) {
      var d = new Date(date);
      var anno = d.getFullYear() + "";
      anno = anno.match(/\d{2}$/);
      var datestring =
        d.getDate() + " " + this.monthNames[d.getMonth() + 1] + " " + anno;
      return datestring;
    },

    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/solicitudes" });
      }
    },
  },
};
</script>

<style lang="scss">

#page-Settle {
  .page-item.active .page-link {
    color: #fff !important;
    background-color:#1c6776 !important;
    border-color:#1c6776 !important;
}
.page-link {
    color: #1c6776 !important;
}
  .data-table {
    tr {
      th {
        &:nth-child(1) {
          min-width: 120px;
        }
        &:nth-child(2) {
          min-width: 170px;
        }
        &:nth-child(3) {
          min-width: 110px;
        }
        &:nth-child(4) {
          min-width: 210px;
        }
        &:nth-child(5) {
          min-width: 110px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#page-Settle {
  .cont-search {
    label {
      font-size: 11px;
      color: #454545;
    }
    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;
        &:focus {
          outline: none;
        }
      }
      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }
  .charge-file{
    border-right: 0;
    border-bottom: 2px solid;
    border-bottom-color: darkblue;
    padding: 20px 0;
  }
  @media (min-width: 768px) {
    .charge-file{
    border-right: 2px solid;
    border-right-color: darkblue;
    border-bottom:0px;
    padding: 0 0;
  }
      }
  .file-upload-img {
    width: 340px;
    height: 200px;
    border-style: dashed;
    border-radius: 25px;
    text-align: center;
    display: flex;
    align-items: center;
  }
  .file-upload-img img {
    width: 100%;
    height: 100%;
  }
  input[type="file"] {
    opacity: 0;
    filter: alpha(opacity=0);
    display: block;
    width: 360px;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .button1 {
    background: #e9ecee;
    color: #1c3a4e;
    //border-radius: 50px;
    height: 24px;
    font-size: 12px;
    text-align: right !important;
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .button2 {
    background: #8d9092;
    color: #ffffff;
    border-color: #8d9092;
    font-family: "Poppins";
    border-radius: 100px;
    height: 42px;
    width: 220px;
    font-size: 14px;
    text-align: center !important;
    padding-left: 2%;
    padding-right: 2%;
    &:hover {
      background: darken(#7a7c7e, 5);
    }
  }
  /*.div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 70px;
    margin-left: 70px;    
  }*/
  .tabla1 {
    border-radius: 5px;
    border: 3px solid #e9ecee;
    border-color: #e9ecee;
    background: #e9ecee;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 90%;
    align-self: center;
  }
  .td1 {
    background: #e9ecee;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .td2 {
    background: #e9ecee;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 14px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td3 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 80px;
    //width: 50px;
    text-align: center;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td4 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: center;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #454545;
    text-align: left !important;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }
  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
}
</style>